import React, { ButtonHTMLAttributes } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  hideTitle?: boolean;
  icon?: IconProp;
  text?: string;
  title?: string;
  isDisabled?: boolean;
  testId?: string;
}

function Button({
  hideTitle,
  isDisabled,
  className = '',
  icon,
  text = '',
  title,
  testId,
  ...props
}: Readonly<ButtonProps>) {
  return (
    <button
      {...props}
      className={`${className} no-navigate ${icon && !hideTitle ? 'ps-3' : ''}`}
      title={title ?? (hideTitle ? text : '')}
      aria-label={text}
      disabled={isDisabled ?? false}
      data-cy={testId}
    >
      {icon && (
        <div className="icon-wrapper no-navigate">
          <FontAwesomeIcon
            icon={icon}
            className={`${!hideTitle ? 'me-3' : ''}`}
            fixedWidth
            style={{ pointerEvents: 'none' }}
          />
        </div>
      )}
      {!hideTitle && text}
    </button>
  );
}

export default Button;
